import React from 'react';
import { useGlobalContext } from 'seagull';
import { MapContactsModal } from "./MapContactsModal";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
export function useOpenMapContactsModalFromInvoice(invoice, integratedInvoice, reloadInvoice) {
  const globalContext = useGlobalContext();
  const {
    USE_INVOICE_VIEWS = false
  } = useFeatureFlags();

  async function getClientContactId() {
    if (!USE_INVOICE_VIEWS) {
      return invoice.clientContactId;
    } else {
      return integratedInvoice.clientContactId;
    }
  }

  return async function openMapContactsModalFromInvoice() {
    const clientContactId = await getClientContactId();
    await globalContext.showModal({
      closeOnClickOutside: false,
      closeOnEscapeKey: false,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(MapContactsModal, {
          dismissModal: dismissModal,
          contactIds: [clientContactId],
          onChange: () => reloadInvoice()
        });
      }
    });
  };
}